<template>
  <div class="page-position column is-12 columns">
    <div class="has-background-white column is-5 is-paddingless">
      <div class="pa-20">
        <p class="is-size-6 has-text-grid-1 has-text-weight-bold pb-20">
          {{titlePage}}
        </p>
        <MsgError
          v-if="isError"
          type="is-danger"
          :msg="msgError"
          @close="msgErrorClose"/>
        <div class="columns is-multiline is-marginless is-paddingless">
          <div class="column is-12 is-paddingless">
            <div class="level">
              <div class="level-left" @click.prevent="gestionDev">
                <upload-image
                  @error="showMsgError($event || $t('general.msgErrorDropdown'))"
                  @dataUrlIcon="icon = $event"/>
              </div>
              <div class="level-item is-width-100p-148px pl-10">
                <div class="column columns is-multiline is-marginless is-paddingless">
                  <div class="column is-paddingless is-12">
                    <b-field class="pl-10">
                      <template slot="label">
                        <p class="is-size-7 has-text-grid-2 has-text-weight-bold">
                          {{$t('ajoutContact.labelChamp.civilite')}}
                        </p>
                      </template>
                      <b-autocomplete
                        expanded
                        :data="civilitesFilter"
                        clear-on-select
                        :value="search"
                        open-on-focus
                        field="libelle"
                        :placeholder="$t('ajoutContact.labelChamp.recherche')"
                        @input="getAllCivilites"
                        @select="civilite => selectCivilite(civilite)">
                          <template slot="header">
                            <a class="is-underline" @click="ajoutNouveauCivilite">
                              <span> {{$t('ajoutContact.labelChamp.newCivilite')}} </span>
                            </a>
                        </template>
                      </b-autocomplete>
                    </b-field>
                  </div>
                  <div class="column columns is-paddingless is-12 is-marginless">
                    <div class="column pltb-0 pr-10 is-6 my-20">
                      <b-field
                      class="pl-10"
                      :type="nomIsError ? 'is-danger' : ''">
                        <template slot="label">
                          <p class="is-size-7 has-text-grid-2  has-text-weight-bold">
                            {{$t('ajoutContact.labelChamp.nom')}}
                            <span class="has-text-danger is-size-8 has-text-weight-normal">
                              {{$t('general.labelObligatoire')}}
                            </span>
                          </p>
                        </template>
                        <b-input v-model="nom"></b-input>
                      </b-field>
                    </div>
                    <div class="column pltb-0 pr-10 is-6 my-20">
                      <b-field class="pl-10">
                        <template slot="label">
                          <p class="is-size-7 has-text-grid-2  has-text-weight-bold">
                            {{$t('ajoutContact.labelChamp.prenoms')}}
                          </p>
                        </template>
                        <b-input v-model="prenom"></b-input>
                      </b-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column columns is-12 is-paddingless is-marginless">
            <div class="column pltb-0 pr-10 is-6 my-20">
              <b-field
                :label="$t('ajoutContact.labelChamp.email')"
                custom-class="is-size-7 has-text-grid-2 has-text-weight-bold">
                <b-input v-model="email"></b-input>
              </b-field>
            </div>
            <div class="column ptbr-0 pl-10 is-6 my-20">
              <b-field
                :label="$t('ajoutContact.labelChamp.telephone')"
                custom-class="is-size-7 has-text-grid-2 has-text-weight-bold">
                <b-input v-model="telephone"></b-input>
              </b-field>
            </div>
          </div>
          <div class="column columns is-12 is-paddingless is-marginless">
            <div class="column pltb-0 pr-10 is-6 my-20">
              <b-field
                :label="$t('ajoutContact.labelChamp.service')"
                custom-class="is-size-7 has-text-grid-2 has-text-weight-bold">
                <b-input v-model="service"></b-input>
              </b-field>
            </div>
            <div class="column ptbr-0 pl-10 is-6 my-20">
              <b-field
                :label="$t('ajoutContact.labelChamp.fonction')"
                custom-class="is-size-7 has-text-grid-2 has-text-weight-bold">
                <b-input v-model="fonction"></b-input>
              </b-field>
            </div>
          </div>
        </div>
        <div class="level mt-50">
          <div class="level-left"></div>
          <div class="level-right">
            <div class="level-item">
              <b-button type="is-white" @click="$emit('close')">
                <p class="is-size-14px has-text-default">
                  {{$t('general.btnAnnuler')}}
                </p>
              </b-button>
            </div>
            <div class="level-item">
              <b-button type="is-primary" @click="ajouterContact">
                <p class="is-size-14px has-text-weight-bold">
                  {{btnValider}}
                </p>
              </b-button>
            </div>
          </div>
        </div>

       <b-modal :active.sync="modalCivilite" :width="640"
          has-modal-card>
          <ModalCreation :civilite-ajouter="civiliteAAjouter"
            @save="selectCivilite"/>
       </b-modal>
      </div>
    </div>
    <div class="column has-background-transparent pointer"
      @click="$emit('close')">
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { v1 as uuidv1 } from 'uuid';
import * as types from '@/store/modules/contacts-mutation-type';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';
import UploadImage from '@/components/general/uploadImage.vue';
import MsgError from '@/components/general/messageErreur';
import { gestionDev } from '@/services/general/general';
import gestionErreur from '@/services/general/gestionErreur';
import ModalCreation from './modalCreation.vue';

const Contact = createNamespacedHelpers('contacts');
const Parametres = createNamespacedHelpers('parametrage');

export default {
  components: {
    UploadImage,
    MsgError,
    ModalCreation,
  },
  props: {
    oneContact: {
      type: Boolean,
      default: false,
    },
    isModification: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    msgError: '',
    isError: false,
    nomIsError: false,
    civilitesFilter: [],
    search: '',
    modalCivilite: false,
    civiliteAAjouter: null,
    iSelectCivilite: false,
    civiliteSearch: null,
  }),
  computed: {
    ...Contact.mapGetters({
      getContact: 'contact',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getCivilites() {
      return this.parametre(PARAMETRES_KEYS.civilite) || [];
    },
    titlePage() {
      return this.isModification
        ? this.$t('ajoutContact.titlePageModif')
        : this.$t('ajoutContact.titlePage');
    },
    btnValider() {
      return this.isModification
        ? this.$t('ajoutContact.btnModifier')
        : this.$t('ajoutContact.btnValider');
    },
    nom: {
      get() {
        return this.getContact.nom;
      },
      set(value) {
        this.setPropietyContact({
          key: 'nom', value});
      },
    },
    prenom: {
      get() {
        return this.getContact.prenom;
      },
      set(value) {
        this.setPropietyContact({
          key: 'prenom', value});
      },
    },
    telephone: {
      get() {
        return this.getContact.telephone;
      },
      set(value) {
        this.setPropietyContact({
          key: 'telephone', value});
      },
    },
    email: {
      get() {
        return this.getContact.email;
      },
      set(value) {
        this.setPropietyContact({
          key: 'email', value});
      },
    },
    service: {
      get() {
        return this.getContact.service;
      },
      set(value) {
        this.setPropietyContact({
          key: 'service', value});
      },
    },
    fonction: {
      get() {
        return this.getContact.fonction;
      },
      set(value) {
        this.setPropietyContact({
          key: 'fonction', value});
      },
    },
    civiliteId: {
      get() {
        return this.getContact.civiliteId;
      },
      set(value) {
        this.setPropietyContact({
          key: 'civiliteId', value});
      },
    },
  },
  methods: {
    ...Contact.mapMutations({
      setPropietyContact: types.SET_PROPRIETY_CONTACT,
      pushContact: types.SET_CONTACTS,
    }),
    ...Contact.mapActions({
      actionsCreateContact: 'createContact',
      actionsEditContact: 'editContact',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    msgErrorClose() {
      this.nomIsError = false;
    },
    showMsgError(msg) {
      this.msgError = msg;
      this.isError = true;
    },
    controleChamp() {
      if (!this.nom.length) this.nomIsError = true;
      else this.nomIsError = false;
      return !this.nomIsError;
    },
    gestionDev() {
      gestionDev()
    },
    async ajouterContact() {
      if (!this.controleChamp()) {
        this.showMsgError(this.$t('general.msgErrorChampObligatoire'));
        return;
      }
      let result = true;
      if (this.isModification) {
        result = await this.actionsEditContact();
      } else {
        this.pushContact();
        if (this.oneContact) {
          const id = this.$route.params.id;
          result = await this.actionsCreateContact(id);
        }
      }
      if (result === true) {
        this.$emit('close');
      } else {
        this.showMsgError(this.$t('ajoutContact.msgErreur'));
      }
    },
    ajoutNouveauCivilite() {
      this.civiliteAAjouter = {
        id: uuidv1(),
        libelle: this.civiliteSearch,
      };
      this.modalCivilite = true;
    },
    getAllCivilites(search) {
      if (search === this.search) return;
      if (!search) {
        if (!this.iSelectCivilite) {
          this.civiliteId = null;
        }
        this.civilitesFilter = cloneDeep(this.getCivilites);
        return;
      }
      this.civiliteSearch = search;
      this.iSelectCivilite = false;
      this.civiliteId = null;
      this.civilitesFilter = cloneDeep(this.getCivilites)
        .filter((civilite) => {
          return civilite.libelle.toLowerCase().includes(search.toLowerCase());
        });
    },
    selectCivilite(civilite) {
      if (!civilite) return;
      this.civiliteSearch = cloneDeep(civilite.libelle);
      this.search = cloneDeep(civilite.libelle);
      this.civiliteId = cloneDeep(civilite.id);
      this.iSelectCivilite = true;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open({ container: null });
    try {
      await this.loadParametres([PARAMETRES_KEYS.civilite]);
      this.civilitesFilter = cloneDeep(this.getCivilites);
      if (this.isModification && this.civiliteId) {
        const civilite = this.getCivilites
          .find((civ) => civ.id === this.civiliteId);
        if (civilite) this.selectCivilite(civilite);
      }
      loadingComponent.close();
    } catch (error) {
      gestionErreur('Erreur lors de la récupération des civilités', error);
      loadingComponent.close();
    }
  },
};
</script>

<style>

</style>
